/* eslint-disable vars-on-top */
/* eslint-disable newline-per-chained-call */
/* eslint-disable strict */
/* eslint-disable no-undef */
/* eslint-disable max-len */

'use strict';

(function UpsellDrawer() {
  var renderDrawer = Simba.Functional.compose(initialiseUpsell, collateData);
  var renderAccessoryDrawer = Simba.Functional.compose(initialiseAccessoryUpsell, collateAccessoryData);

  var data = {
    originalVariantSize: '',
    qualifyingItemHandles: [],
    qualifyingItem: {},
    qualifyingItemMeta: {},
    canUpsell: false,
    upsellItem: {},
    upsellVariant: {},
    templateValues: {
      upgradeForPrice: '',
      upgradePricePerDay: ''
    },
    upsellProducts: [],
    upsellProductMeta: {}
  };

  var publicAPI = {
    open: showUpsell,
    close: hideUpsell,
    isOpened: isUpsellOpen,
    upsellAccept: upsellAccept,
    invokeUpsell: invokeUpsell
  };

  var format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"£{{amount}}"'));
  var formatWithoutTrailingZeros = Simba.Functional.partial(
    Simba.Money.format,
    Simba.Liquid.string('"£{{amount_no_decimals}}"')
  );
  var currencySuffixArray = [
    { countryCode: 'en_GB', suffix: 'p', format: false },
    { countryCode: 'fr_FR', suffix: '', format: true },
    { countryCode: 'es_ES', suffix: '¢', format: false },
    { countryCode: 'ca_CA', suffix: '¢', format: false }
  ];
  var currencySuffix = currencySuffixArray.find((country) => country.countryCode === Simba.Lang.base_locale);

  function collateData(upsellObj) {
    return { upsell: upsellObj, dismissTrigger: document.querySelector('[data-upsell-dismiss]') };
  }

  function collateAccessoryData(upsellObj) {
    return { upsell: upsellObj, dismissTrigger: document.querySelector('[data-upsell-accessory-dismiss]') };
  }

  Simba.UpsellDrawer = publicAPI;
  window.addEventListener('load', function () {
    renderDrawer();
    renderAccessoryDrawer();
  });

  function initialiseUpsell(init) {
    // Clickaway listener
    init.dismissTrigger.addEventListener('click', hideUpsell);
    // Close drawer on escape key
    document.addEventListener('keydown', escapeKeyClose);
    Simba.Event.emit('upsellInitialised');

    return init;
  }

  function initialiseAccessoryUpsell(init) {
    // Clickaway listener
    init.dismissTrigger.addEventListener('click', hideAccessoryUpsell);
    // Close drawer on escape key
    document.addEventListener('keydown', escapeKeyClose);
    Simba.Event.emit('upsellInitialised');

    return init;
  }

  /**
   * Called from Simba.AjaxCart.cartAdd (item/s added to cart) and handles population and display of the drawer
   * Returns false if no mattress was added to the cart or the additions include excluded item/s
   * @param {object}    items  The response from the Shopify API cart/add - An array of line item objects representing each item added
   * @param {string}    type   The type of upsell being invoked eg. 'mattress' or 'accessory'.
   * @return {boolean}
   */
  async function invokeUpsell(items, type) {
    var upsellContinue = canOfferUpsell(items, type);
    var upsellVariantSize;
    if (upsellContinue) {
      data.originalVariantSize = data.originalItem.variant_title.split(':')[0];
      // Unless France
      if (data.originalVariantSize === data.originalItem.variant_title) {
        upsellVariantSize = data.originalItem.variant_title.split('x');
        data.originalVariantSize = upsellVariantSize[0] + 'x' + upsellVariantSize[1];
      }
      if (type === 'mattress') {
        data.canUpsell = checkUpsell(data.originalItem).then((applies) => {
          if (applies) {
            setItemPricing().then(createUpsell).then(showUpsell);
          }
          return true;
        });
      } else {
        data.upsellProductMeta = Simba.Upsell.accessories.sizes[data.originalVariantSize].upsell_products;
        getUpsellProducts().then(populateBundleUpsells).then(showAccessoryUpsell);
      }
    }
    return false;
  }

  /**
   * Perform required checks to ensure we can offer an upsell
   * @param {Object}  items  The response from the Shopify API cart/add - An array of line item objects representing each item added
   * @param {string}  type   The type of upsell being invoked eg. 'mattress' or 'accessory'.
   * @return {boolean}
   */
  function canOfferUpsell(items, type) {
    var itemHandle;
    var hasExclusions;
    var upsellRejected;
    var mattressItem = items.find((item) => item.product_type === Simba.Upsell.mattress.product_type);
    var handleInInclusionList = false;

    if (typeof mattressItem !== 'object') return false;
    if (type === 'accessory') {
      items.forEach(function (item) {
        var match = Simba.Upsell.accessories.product_handles.find((handle) => handle === item.handle);
        if (match !== undefined) {
          handleInInclusionList = true;
        }
      });
      if (!handleInInclusionList) {
        return false;
      }
    }
    itemHandle = mattressItem.handle;
    hasExclusions = hasExcludedItem(items, type);
    upsellRejected = hasRejectedUpsell(itemHandle);
    if (mattressItem) {
      if (hasExclusions || upsellRejected) {
        return false;
      }
      data.originalItem = mattressItem;
      return true;
    }
    return false;
  }

  /**
   * Checks whether the cart add includes items which should stop the upsell being offered
   * @param {Object}    items  The line item/s added to the cart (response from Shopify API cart/add)
   * @return {boolean}
   */
  function hasExcludedItem(items, type) {
    var foundExclude = false;
    var globalExcludesArr = Simba.Upsell.mattress.exclusions;
    if (type === 'mattress') {
      items.forEach((item) => {
        if (globalExcludesArr.includes(item.handle)) {
          foundExclude = true;
          return foundExclude;
        }
        return true;
      });
    } else {
      Simba.Cart.items.forEach((item) => {
        if (Simba.Upsell.accessories.exclusions.includes(item.handle)) {
          foundExclude = true;
          return foundExclude;
        }
        return true;
      });
    }

    return foundExclude;
  }

  /**
   * Checks whether the customer has already rejected this upsell during this visit
   * @param   {object}   itemHandle  The handle for the line item added to the cart (response from Shopify API cart/add)
   * @return  {boolean}
   */
  function hasRejectedUpsell(itemHandle) {
    var upsellHistory = JSON.parse(sessionStorage.getItem('simba:upsells'));
    if (upsellHistory) {
      return upsellHistory.rejected.includes(itemHandle);
    }
    return false;
  }

  /**
   * Check the chosen product exists in the upsell metafield
   * and set an indicator accordingly.
   * Makes a Shopify API call to get upsell product details
   * @param {object}    item  The item, added to the basket, that we want to check
   * @return {boolean}  True if upsell is allowed, false otherwise
   */
  async function checkUpsell(item) {
    await getProtectorForSize();

    if (Object.prototype.hasOwnProperty.call(Simba.Upsell.mattress.products, item.handle)) {
      if (Simba.Upsell.mattress.products[item.handle].enabled) {
        data.qualifyingItemMeta = Simba.Upsell.mattress.products[item.handle];
        data.qualifyingItem = item;

        // Get upsell product data from Shopify
        data.upsellItem = await makeAPICall(window.Simba.Lang.url + `/products/${data.qualifyingItemMeta.upsell_products[0].handle}.js`, 'GET');

        // Store the correct upsell variant details
        data.upsellVariant = data.upsellItem.variants.find((variant) => variant.title.split(':')[0] === data.originalVariantSize);

        // Unless we're in France?
        if (typeof data.upsellVariant === 'undefined') {
          data.upsellVariant = data.upsellItem.variants.find((variant) => {
            var upsellVariantSize = variant.title.split('x');
            upsellVariantSize = upsellVariantSize[0] + 'x' + upsellVariantSize[1];
            return upsellVariantSize === data.originalVariantSize;
          });
        }

        // Check We Have A Match & Return
        if (typeof data.upsellVariant !== 'undefined') {
          data.canUpsell = true;
          return true;
        }
      }
    }

    // No Match
    data.canUpsell = false;
    return false;
  }

  /**
   * Set product pricing information for both the chosen and
   * upsold products... Primarily from the Simba.Product object
   * @return {boolean}
   */
  async function setItemPricing() {
    var lowestInstalmentPriceRaw = 0;
    var upgradeForPriceRaw;
    var qualifyingItemData = await Simba.ProductAsync.load(data.qualifyingItem.variant_id);
    var upsellItemData = await Simba.ProductAsync.load(data.upsellVariant.id);

    // Get qualifying product pricing
    data.qualifyingItem = {
      ...data.qualifyingItem,
      hasDiscount: qualifyingItemData.hasDiscount,
      hasFinance: qualifyingItemData.hasFinance,
      originalPrice: qualifyingItemData.originalPrice,
      originalPriceFormatted: qualifyingItemData.originalPriceFormatted,
      originalPriceFormattedWithoutTrailingZeros: qualifyingItemData.originalPriceFormattedWithoutTrailingZeros,
      price: qualifyingItemData.price,
      priceFormatted: qualifyingItemData.priceFormatted,
      priceFormattedWithoutTrailingZeros: qualifyingItemData.priceFormattedWithoutTrailingZeros,
      lowestInstalmentPriceRaw: qualifyingItemData.finance.lowestInstalmentPriceFormatted.replace(/[£$€]/g, '').trim() * 100
    };

    // Get upsell product pricing
    // 'Raw' the lowest finance instalment price
    lowestInstalmentPriceRaw = upsellItemData.finance.lowestInstalmentPriceFormatted.replace(/[£$€]/g, '').trim() * 100;
    data.upsellVariant = {
      ...data.upsellVariant,
      handle: data.upsellItem.handle,
      hasDiscount: upsellItemData.hasDiscount,
      hasFinance: upsellItemData.hasFinance,
      originalPrice: upsellItemData.originalPrice,
      originalPriceFormatted: upsellItemData.originalPriceFormatted,
      originalPriceFormattedWithoutTrailingZeros: upsellItemData.originalPriceFormattedWithoutTrailingZeros,
      price: upsellItemData.price,
      priceFormatted: upsellItemData.priceFormatted,
      priceFormattedWithoutTrailingZeros: upsellItemData.priceFormattedWithoutTrailingZeros,
      discountAlwaysShown: upsellItemData.discount_always_shown,
      hasInstalment12Hidden: upsellItemData.finance.hasInstalment12Hidden,
      instalmentPriceFormatted: upsellItemData.finance.instalmentPriceFormatted,
      lowestInstalmentPriceFormatted: upsellItemData.finance.lowestInstalmentPriceFormatted,
      lowestInstalmentPriceRaw: lowestInstalmentPriceRaw
    };

    // Overwrite With Upgrade Amount If Upgrade Pricing Set
    if (data.qualifyingItemMeta.upsell_products[0].use_upgrade_finance) {
      data.upsellVariant.lowestInstalmentPriceFormatted = format(
        data.upsellVariant.lowestInstalmentPriceRaw - data.qualifyingItem.lowestInstalmentPriceRaw
      );
    }

    // Save Up To
    upgradeForPriceRaw = data.upsellVariant.price - data.qualifyingItem.price;
    data.templateValues.upgradeForPrice = formatWithoutTrailingZeros(upgradeForPriceRaw);
    data.templateValues.upgradePricePerDay = currencySuffix.format
      ? format(Math.round(upgradeForPriceRaw / 3650, 0))
      : Math.round(upgradeForPriceRaw / 3650, 0);
    Simba.Upsell.item = data.upsellVariant;
    return true;
  }

  // DRAWER CONTENT CREATION METHODS
  /**
   * Clones the required templates and populates the data accordingly
   * @return {boolean}  Always true
   */
  async function createUpsell() {
    var upsellTemplate = document.getElementById('mattressUpsell');
    var benefitTemplate = document.getElementById('benefitItem');
    var financeTemplatePayNow = document.getElementById('financePayNow');
    var financeTemplateSplit = document.getElementById('financeSplitOptions');
    var cloneFinanceElement;
    var financeRowTemplate = document.getElementById('financeRowInstalment');
    var upsellContainer = document.querySelector('[data-upsell-drawer]');
    var benefitContainer;
    var financeContainer;
    var financeInstalmentContainer;
    var cloneElement;
    var upgradeBannerContent;
    var upsellData = getUpsellData();

    upsellContainer.innerHTML = '';
    cloneElement = upsellTemplate.content.cloneNode(true);
    benefitContainer = cloneElement.querySelector('#upsell-benefits');
    financeContainer = cloneElement.querySelector('.product-finance');

    // Populate the template
    /* Image and overlay content */
    cloneElement.querySelector('#upsell-product-image__image').setAttribute('src', upsellData.image);
    cloneElement.querySelector('#upsell-product-image__image').setAttribute('alt', data.upsellItem.handle);
    upgradeBannerContent = "Upgrade for <span id='upsell-upgrade-price' class='upsell-highlight-text'>only |UPGRADE_FOR|</span>";
    upgradeBannerContent = upgradeBannerContent.replace('|UPGRADE_FOR|', data.templateValues.upgradeForPrice);
    cloneElement.querySelector('.upsell-banner__text').insertAdjacentHTML('beforeend', upgradeBannerContent);

    document.querySelector('.ppd-price').innerHTML = data.templateValues.upgradePricePerDay.toString().replace(' ', '') + currencySuffix.suffix;

    /* Title and Price */
    cloneElement.querySelector('#upsell-title__text').innerHTML = upsellData.productTitle;
    if (Simba.Upsell.mattress.price_in_title) {
      /* Only show if the price has been discounted */
      if (data.upsellVariant.originalPrice !== data.upsellVariant.price) {
        cloneElement.querySelector('#upsell-title-price__original').innerText = data.upsellVariant.originalPriceFormatted;
      }
      cloneElement.querySelector('#upsell-title-price__discounted').innerText = data.upsellVariant.priceFormatted;
    } else {
      cloneElement.querySelector('#upsell-title-price').hidden = true;
      cloneElement.querySelector('#upsell-title__text').style.width = 'unset';
    }

    /* Benefits */
    Simba.Upsell.mattress.benefits.forEach(async (benefit) => {
      var cloneBenefitElement;
      var benefitImage = Simba.Upsell.benefit_images[benefit.id];

      const protector = await getProtectorForSize();

      if (Simba.Upsell.mattress.products[data.qualifyingItem.handle].upsell_products[0].show_benefits.includes(benefit.id)) {
        cloneBenefitElement = benefitTemplate.content.cloneNode(true);
        cloneBenefitElement.querySelector('.benefit-row').style = `--animation-order: ${benefit.id};`;
        cloneBenefitElement.querySelector('#benefit-icon__image').setAttribute('src', benefitImage);
        cloneBenefitElement.querySelector('#benefit-icon__image').setAttribute('alt', benefit.title);
        // No title? No problem, ensure the description gridarea covers the space!
        if (benefit.title === '') {
          cloneBenefitElement.querySelector('.benefit-row').classList.add('benefit-row__no-title');
          cloneBenefitElement.querySelector('.benefits-description').classList.add('benefits-description__no-title');
        } else {
          cloneBenefitElement.querySelector('#benefit-title__text').innerHTML = benefit.title;
        }
        cloneBenefitElement.querySelector('#benefit-description__text').innerHTML = benefit.text.replace('|PRICE|', protector.originalPriceFormatted);
        benefitContainer.append(cloneBenefitElement);
      }
    });

    /* Finance */
    /**
     * There are two finance box types currently:
     * 1. 'split' - Left side shows split payments/instalments, right side shows novuna finance (used in UK)
     * 2. 'pay-now' - Left side shows the full price (pay now), right side shows lowest Alma payment
     */
    if (Simba.Upsell.mattress.finance_type === 'split') {
      cloneFinanceElement = financeTemplateSplit.content.cloneNode(true);
      financeInstalmentContainer = cloneFinanceElement.querySelector('#finance-instalments');

      // Change Title Text If Show Upgrade Payment
      if (data.qualifyingItemMeta.upsell_products[0].use_upgrade_finance) {
        cloneFinanceElement.querySelector('[data-upgrade-title]').innerText = cloneFinanceElement
          .querySelector('[data-upgrade-title]')
          .getAttribute('data-upgrade-title');
      }

      if (Simba.Upsell.settings.finance_calc_visible) {
        cloneFinanceElement.querySelector('#finance-left-images').innerHTML = upsellData.financeImages;
        cloneFinanceElement.querySelector('#finance-content-left-header__text').innerText = format(upsellData.instalmentPrice);
        financeInstalmentContent(financeInstalmentContainer, financeRowTemplate);
      }
      if (Simba.Upsell.settings.enable_klarna) {
        cloneFinanceElement.querySelector('#finance-content-right-header__text').innerText = data.upsellVariant.lowestInstalmentPriceFormatted;
        cloneFinanceElement.querySelector('#finance-content-right-footer__term').innerText = upsellData.exampleTerm;
        cloneFinanceElement.querySelector('#finance-content-right-footer__rate').innerText = Simba.Upsell.mattress.finance_example_rate;
      }
      financeContainer.append(cloneFinanceElement);
    } else if (Simba.Upsell.mattress.finance_type === 'pay-now') {
      cloneFinanceElement = financeTemplatePayNow.content.cloneNode(true);
      cloneFinanceElement.querySelector('#finance-content-left-header__text-price').dataset.hasDiscount = data.upsellVariant.hasDiscount;
      // Only show the strikethrough if the product has a discount
      // Otherwise check if we're showing a French discount badge
      if (data.upsellVariant.hasDiscount && data.upsellVariant.originalPrice !== data.upsellVariant.price) {
        cloneFinanceElement.querySelector('#finance-content-left-header__text-price-original').innerText = data.upsellVariant.originalPriceFormatted;
      }
      cloneFinanceElement.querySelector('#finance-content-left-header__text-price-actual').innerText = data.upsellVariant.priceFormatted;
      cloneFinanceElement.querySelector('#product-finance__per-month-amount').innerText = data.upsellVariant.lowestInstalmentPriceFormatted;
      financeContainer.append(cloneFinanceElement);
    }

    /* "Form" */
    cloneElement.querySelector('[data-upsell-select]').options[0].value = data.upsellVariant.id;
    cloneElement.querySelector('[data-upsell-select]').options[0].text = data.upsellVariant.title;
    if (upsellData.bogoItems) {
      cloneElement.querySelector('[data-upsell-select]').options[0].bogoMulti = upsellData.bogoItems;
      cloneElement.querySelector('[data-upsell-select]').options[0].dataset.multi = upsellData.bogoItems;
      cloneElement.querySelector('[data-remove-protector]').value = upsellData.bogoItems;
    }
    cloneElement.querySelector('[data-qualifying-product]').value = data.qualifyingItem.id;
    // Data for GTM
    cloneElement.querySelector('[data-upsell-mattress-type]').dataset.upsellMattressType = data.qualifyingItemMeta.upsell_products[0].gtm_handle;

    upsellContainer.append(cloneElement);
    initEventListeners();
    return true;
  }

  /** Event listeners required by the upsell drawer */
  function initEventListeners() {
    var closeTrigger;
    var upgradeTrigger;
    var elements;
    /* Event listeners */
    /* FINANCE */
    /* Finance popup open/close */
    if (Simba.Upsell.settings.finance_calc_visible) {
      // DIVIDEBUY & SPLITIT
      document
        .querySelector('[data-js-collapsible="upsell-12mo-popup"]')
        .addEventListener('click', () => showFinancePopup('[data-finance-calculator="upsell-12mo-popup"]'));
      document
        .querySelector('[data-js-close-collapsible="upsell-12mo-popup"]')
        .addEventListener('click', () => showFinancePopup('[data-finance-calculator="upsell-12mo-popup"]'));
      /* Finance instalment rows */
      elements = document.querySelectorAll('[data-upsell-collapsible="finance_calculator_upsell-12mo-popup"]');
      elements.forEach((element) => {
        element.addEventListener('click', collapseFinance);
      });
    }

    /* DRAWER */
    /* Accept/Reject */
    closeTrigger = document.querySelector('[data-upsell-drawer-close]');
    upgradeTrigger = document.querySelector('[data-upsell-accept]');
    closeTrigger.addEventListener('click', rejectUpsell);
    upgradeTrigger.addEventListener('click', upsellAccept);
  }

  /**
   * Clone and populate the finance instalment rows
   * @param   {object}  container   The cloned dom element within which to append the instalment rows
   * @param  {object}   template    The finance row template element
   */
  function financeInstalmentContent(container, template) {
    Simba.Upsell.settings.finance_calc_months.forEach((instalment, index) => {
      var instalmentNumber = instalment * 1;
      var interest = 0.0;
      var interestRate = interest.toString();
      var pricePlusInterest = format(data.upsellVariant.price);
      var monthlyPrice = format(data.upsellVariant.price / instalmentNumber);
      var hidden = index === 0 ? '' : 'hidden';
      var expanded = index === 0 ? 'true' : 'false';
      var cloneFinanceRow;
      var interestString = `(${interestRate}% APR)`;
      cloneFinanceRow = template.content.cloneNode(true);

      cloneFinanceRow.querySelector('#finance-row-instalment__button').setAttribute('aria-expanded', expanded);
      cloneFinanceRow.querySelector('#finance-row-instalment__amount').innerText = instalment;
      cloneFinanceRow.querySelector('#finance-row-instalment__monthly').dataset.financeCalculatorInstalment = instalment;
      cloneFinanceRow.querySelector('#finance-row-instalment__monthly').innerText = monthlyPrice;
      cloneFinanceRow.querySelector('#finance-row-interest').hidden = hidden;
      cloneFinanceRow.querySelector('#finance-row-interest__amount').innerText = format(interest);
      cloneFinanceRow.querySelector('#finance-row-interest__rate').innerHTML = interestString;
      cloneFinanceRow.querySelector('#finance-row-price').innerText = pricePlusInterest;
      container.append(cloneFinanceRow);
    });
  }

  /**
   * Generate the finance installment price
   * @return  {string}  Return the price as a fixed string at 2 decimal places
   */
  function getFinanceInstallmentPrice() {
    if (data.qualifyingItemMeta.upsell_products[0].use_upgrade_finance) {
      return parseFloat((data.upsellVariant.price - data.qualifyingItem.price) / 12 / 100).toFixed(2);
    }
    return parseFloat(data.upsellVariant.price / 12 / 100).toFixed(2);
  }

  /**
   * Get some generated and non-product related data
   * @return  {object}  Return an object containing the required data
   */
  function getUpsellData() {
    var bogoItems = getBogoItems();
    var mattressUpsellData = {};
    var financeImages;
    var itemImg;
    var titleFormatted;
    var productTitle;

    if (data.qualifyingItemMeta.upsell_products[0].image) {
      itemImg = data.qualifyingItemMeta.upsell_products[0].image;
    } else {
      itemImg =
        data.upsellItem.images[1] === null
          ? 'https://cdn.simbasleep.com/b0defcef-c838-42da-afdc-81fe91083a5b/cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
          : data.upsellItem.images[1].replace(/(\.[^.]*)$/, '_430x309$1');
    }

    if (Simba.Upsell.mattress.product_type === 'Mattress') {
      titleFormatted = data.upsellItem.title
        .replace('The Simba', '')
        .replace('Pro', '<span class="upsell-highlight-text">Pro</span>')
        .replace('Luxe', '<span class="upsell-highlight-text">Luxe</span>');
    } else if (Simba.Upsell.mattress.product_type === 'Matelas') {
      titleFormatted = data.upsellItem.title
        .replace('Le Matelas ', "<span class='upsell-highlight-text'>l'")
        .replace('Original', 'Original ?</span>')
        .replace('Pro', 'Pro ?</span>')
        .replace('Luxe', 'Luxe ?</span>');
    } else {
      titleFormatted = '';
    }
    productTitle = "Why not get a " + titleFormatted + "";
    const instalmentPrice = getFinanceInstallmentPrice();
    const exampleTerm = Simba.Upsell.mattress.finance_example_term / 12;
    financeImages = `
      <img class="" src="${Simba.Upsell.settings.finance_calculator_img}" alt="${Simba.Upsell.settings.finance_calculator_img_alt}" loading="lazy" />
    `;
    if (Simba.Upsell.settings.finance_calculator_two_img) {
      financeImages += `
        <img class="ml-30" src="${Simba.Upsell.settings.finance_calculator_two_img}" alt="${Simba.Upsell.settings.finance_calculator_two_img_alt}" loading="lazy" />
      `;
    }

    mattressUpsellData = {
      image: itemImg,
      productTitle: productTitle,
      bogoItems: bogoItems,
      instalmentPrice: instalmentPrice,
      exampleTerm: exampleTerm,
      financeImages: financeImages
    };
    return mattressUpsellData;
  }

  /**
   * Get product discount percentage or return 0 if there isn't one
   * @param   {handle}  The handle of the product to get the discount for
   * @return  {number}  Return the discount percentage decimal value
   */
  function getProductDiscount(handle = null) {
    var discount;
    if (handle === null) {
      return 0;
    }
    discount = Simba.ProductDiscount.discount[handle].percentage || 0;
    discount /= 100;
    return discount;
  }

  /**
   * Helper function to make a fetch call to the Shopify API
   * @param {string}    endpoint  URL of the Shopify endpoint
   * @param {string}    method    The HTTP method
   * @param {Object}    headers   Any extra headers to be passed with the call
   * @param {Object}    body      The body of the API call if POST
   * @return {Object}   The JSON respobnse returned from Shopify
   */
  async function makeAPICall(endpoint, method, headers = {}, body = null) {
    var requestOptions = {
      method: method,
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    };
    if (method === 'POST') {
      requestOptions.body = JSON.stringify(body);
    }
    const response = await fetch(endpoint, requestOptions);
    const returnVal = await response.json();
    return returnVal;
  }

  /**
   * Get the ID of any BOGO items associated with the
   * upsold product (e.g. free mattress protector)
   * This is used to populate data attributes on the
   * product variant select element
   * @return {boolean|string} Returns string of bogo product ID's otherwise false if none exist
   */
  function getBogoItems() {
    var bogoData;
    var itemIndex;
    var upsellVariantId = data.upsellVariant.id.toString();
    var freebieProductString = '';
    if (document.querySelector('[data-ajax-bogo-config]')) {
      bogoData = JSON.parse(document.querySelector('[data-ajax-bogo-config]').innerHTML);
      if (bogoData.bogoBuys.includes(upsellVariantId)) {
        itemIndex = bogoData.bogoBuys.indexOf(upsellVariantId);
        freebieProductString = bogoData.bogoGets[itemIndex].toString();
        return freebieProductString;
      }
      return false;
    }
    return false;
  }

  /**
   * Get the value of the matching protector, based on size chosen
   * For use in the benefits text
   * @return {boolean|object} Returns an object containing the correct protector ID and price, else false
   */
  async function getProtectorForSize() {
    var protector = false;
    var protectorSize;
    var sizeArray = [];

    // Lookup Product Data
    const productData = await Simba.ProductAsync.data(Simba.Upsell.mattress.protector_handle);

    // Find correct size in protextor entries
    // eslint-disable-next-line no-unused-vars
    for (const [key, product] of Object.entries(productData)) {
      protectorSize = product.variantTitle.split(':')[0];
      // Unless we're in France?
      if (protectorSize === product.variantTitle) {
        sizeArray = product.variantTitle.split('x');
        protectorSize = sizeArray[0] + 'x' + sizeArray[1].replace('cm', '');
      }
      if (protectorSize === data.originalVariantSize) {
        protector = {
          id: product.id,
          originalPriceFormatted: product.originalPriceFormattedWithoutTrailingZeros
        };
        break;
      }
    }

    return protector;
  }

  /**
   * Click handlers for the finance 'i' icons
   * If this is the novuna popup, load the novuna calc too
   * @param   {string}    el    The id of the element to show
   * @param   {boolean}   init  Should we also load the finance calculator
   */
  function showFinancePopup(el, init = false) {
    var element = document.querySelector(el);
    if (init) {
      document.querySelector('#klarna-upsell').dataset.purchaseAmount = data.upsellVariant.price;
      window.Klarna?.OnsiteMessaging?.refresh();
    }
    element.hidden = !element.hidden;
  }

  /**
   * Accordian expand/collapse for the instalment popup rows
   * @param {object}  ev  The target element
   */
  function collapseFinance(ev) {
    var elements = document.querySelectorAll('[data-upsell-collapsible="finance_calculator_upsell-12mo-popup"]');
    var showPanel = ev.target.nextElementSibling;
    elements.forEach((element) => {
      element.nextElementSibling.setAttribute('hidden', true);
    });
    if (showPanel) {
      showPanel.removeAttribute('hidden');
    } else {
      ev.target.parentNode.parentNode.nextElementSibling.removeAttribute('hidden');
    }
  }

  /**
   * Invoked when the customer chooses to 'reject' the upsell offer. Stores the product
   * handle in sessionStorage
   * @return {boolean}  Always true
   */
  function setStorage() {
    // Clear the decks of any existing instances of our current upsell handle
    // var upsellHistory = sessionStorage.getItem('simba:upsells') ? JSON.parse(sessionStorage.getItem('simba:upsells')) : { rejected: [] };
    var upsellHistory = { rejected: [] };
    var upsellRejected = upsellHistory.rejected;
    var sessionObj;
    if (upsellRejected.includes(data.qualifyingItem.handle)) {
      upsellRejected = upsellRejected.filter((item) => item !== data.qualifyingItem.handle);
    }
    sessionObj = {
      rejected: [...upsellHistory.rejected, data.qualifyingItem.handle]
    };
    sessionStorage.setItem('simba:upsells', JSON.stringify(sessionObj));
    return true;
  }

  /** Show the upsell drawer */
  function showUpsell() {
    document.querySelector('html').classList.add('upsell-drawer-open');
    document.body.classList.add('upsell-drawer-show');
    Simba.Event.emit('upsellOpened');
    return true;
  }

  /** Hide the upsell drawer */
  function hideUpsell() {
    document.querySelector('html').classList.remove('upsell-drawer-open');
    document.body.classList.remove('upsell-drawer-show');
    return true;
  }

  /** Escape key close the upsell */
  function escapeKeyClose(evt) {
    if (evt.keyCode === 27 && isUpsellOpen()) {
      hideUpsell();
    }
  }

  /**
   * Return true if the drawer is open
   * @return {boolean}
   */
  function isUpsellOpen() {
    return document.body.classList.contains('upsell-drawer-show');
  }

  // ADD/REJECT METHODS
  /*
   * User has clicked the accept button
   * Identify whether the chosen (not upsold) product has a free mattress protector and
   * ensure the cart is adjusted accordingly
   * We also want to reduce the chosen item quantity
   * Then we call the add to cart function to add our upsold product
   */
  function upsellAccept() {
    const originalProductId = $('[data-qualifying-product]').val();
    var protectorId;
    window.Simba.AjaxCart.getCart()
      .then((cartContent) => {
        var items = { updates: {} };
        var quantity;
        var id;
        cartContent.items.forEach((cartItem) => {
          // Check for existing protector(s)
          if (protectorId !== false && cartItem.final_line_price === 0) {
            protectorId = cartItem.key;
            quantity = cartItem.quantity;
            items.updates = { ...items.updates, [protectorId]: 1 };
          }
          if (originalProductId === cartItem.id.toString()) {
            quantity = cartItem.quantity - 1;
            id = cartItem.key;
            items.updates = { ...items.updates, [id]: quantity };
          }
        });
        return items;
      })
      .then((cart) => {
        window.Simba.AjaxCart.upsellFormSubmit(cart, false);
      })
      .then(hideUpsell);
  }

  /**
   * Update the history sessionStorage if the user rejects the upsell and close the drawer
   * @return {boolean}
   */
  function rejectUpsell() {
    setStorage();
    hideUpsell();
    return false;
  }

  function rejectAccessoryUpsell() {
    setStorage();
    hideAccessoryUpsell();
    return false;
  }

  /**
   * All functions below here are for the accessory upsell CRO - SIM-3221
   */
  async function getUpsellProducts() {
    var priceCalc = 0;
    var percentageAmount = 0;
    var itemDiscountPercent = 0;
    data.upsellProductMeta.map(async (product, idx) => {
      // Lookup Product Data
      const productData = await Simba.ProductAsync.load(product.variant_id);

      data.upsellProducts[idx] = {
        handle: product.handle,
        variant_id: product.variant_id,
        benefits: product.benefits,
        productTitle: productData.productTitle,
        description: product.description,
        hasDiscount: productData.hasDiscount,
        originalPrice: productData.originalPrice,
        originalPriceFormatted: productData.originalPriceFormatted,
        originalPriceFormattedWithoutTrailingZeros: productData.originalPriceFormattedWithoutTrailingZeros,
        price: productData.price,
        priceFormatted: productData.priceFormatted,
        priceFormattedWithoutTrailingZeros: productData.priceFormattedWithoutTrailingZeros,
        discountAlwaysShown: productData.discount_always_shown
      };
      data.upsellProducts[idx].quantity = product.quantity;
      data.upsellProducts[idx].image = product.image;
      data.upsellProducts[idx].imageMobile = product.image_mobile;
      // Discount
      data.upsellProducts[idx].discountPercent = Simba.ProductDiscount.discount[product.handle];
      // Apply qualifying item discount
      itemDiscountPercent = getProductDiscount(product.handle);
      // Price
      percentageAmount = data.upsellProducts[idx].originalPrice * itemDiscountPercent;
      priceCalc = data.upsellProducts[idx].originalPrice - percentageAmount;
      data.upsellProducts[idx].price = priceCalc;
      data.upsellProducts[idx].priceFormatted = format(priceCalc);
      data.upsellProducts[idx].priceFormattedWithoutTrailingZeros = formatWithoutTrailingZeros(priceCalc);
      data.upsellProducts[idx].savingTotalRaw = data.upsellProducts[idx].originalPrice - priceCalc;
      return true;
    });
  }

  /**
   * Clones the desktop and mobile templates and populates with the relevant data.
   * Loops on the upsell products and generates a product card for each
   * @return {boolean}
   */
  async function populateBundleUpsells() {
    var imageElement;
    var discount = 0;
    var productCardData = {
      savingAmount: '',
      originalPriceFinal: '',
      priceFinal: '',
      image: {
        src: {
          desktop: '',
          mobile: ''
        },
        alt: ''
      },
      title: '',
      quantity: 0,
      benefitsRows: ''
    };
    var discountContainer = document.querySelector('#discount-percent-accessory');
    var cardContainer = document.querySelector('#product-container');
    var cardTemplate = document.getElementById('upsellProductCard');
    var cardTemplateMobile = document.getElementById('upsellProductCardMobile');
    var cloneCard;
    var cloneCardMobile;
    var button;
    cardContainer.innerHTML = '';
    data.upsellProducts.forEach((item) => {
      // For CRO assuming the same discount for all upsell products
      cloneCard = cardTemplate.content.cloneNode(true);
      cloneCardMobile = cardTemplateMobile.content.cloneNode(true);
      productCardData = createProductCard(item);
      discount = item.discountPercent.percentage;
      // Add the data to the template -- DESKTOP --
      cloneCard.querySelector('.product-card-header__title').innerHTML = productCardData.title.desktop;
      cloneCard.querySelector('.product-card-header__subtitle').innerHTML = productCardData.description.desktop;
      cloneCard.querySelector('.product-card-header__saving_left').textContent = productCardData.savingAmountLeft.replace('|PERCENT|', discount);
      cloneCard.querySelector('.product-card-header__saving_right').textContent = productCardData.savingAmountRight;
      imageElement = cloneCard.querySelector('#item-image');
      imageElement.src = productCardData.image.src.desktop;
      imageElement.alt = productCardData.image.alt;
      cloneCard.querySelector('.product-card-body__benefit-container').innerHTML = productCardData.benefitsRows;
      cloneCard.querySelector('.product-card-price__strikethrough').textContent = productCardData.originalPriceFinal;
      cloneCard.querySelector('.product-card-price__actual').textContent = productCardData.priceFinal;
      button = cloneCard.querySelector('[data-variant-id]');
      button.setAttribute('data-variant-id', productCardData.variantId);
      button.setAttribute('data-variant-quantity', productCardData.quantity);
      // Add the data to the template -- MOBILE --
      cloneCardMobile.querySelector('.product-card-header__title').innerHTML = productCardData.title.mobile;
      cloneCardMobile.querySelector('.product-card-header__subtitle').innerHTML = productCardData.description.mobile;
      cloneCardMobile.querySelector('.product-card-header__saving_left').textContent = productCardData.savingAmountLeft.replace(
        '|PERCENT|',
        discount
      );
      cloneCardMobile.querySelector('.product-card-header__saving_right').textContent = productCardData.savingAmountRight;
      imageElement = cloneCardMobile.querySelector('#item-image');
      imageElement.src = productCardData.image.src.mobile;
      imageElement.alt = productCardData.image.alt;
      cloneCardMobile.querySelector('.product-card-body__benefit-container').innerHTML = productCardData.benefitsRows;
      cloneCardMobile.querySelector('.product-card-price__strikethrough').textContent = productCardData.originalPriceFinal;
      cloneCardMobile.querySelector('.product-card-price__actual').textContent = productCardData.priceFinal;
      button = cloneCardMobile.querySelector('[data-variant-id]');
      button.setAttribute('data-variant-id', productCardData.variantId);
      button.setAttribute('data-variant-quantity', productCardData.quantity);
      // Append the content
      cardContainer.append(cloneCard);
      cardContainer.append(cloneCardMobile);
    });

    var discountBanner = "<div id='discount-long'>BY BUYING A MATTRESS YOU'VE QUALIFIED FOR <br><span class='upsell-highlight-text'>|PERCENT|% OFF HYBRID ACCESSORIES</span></div>";
    discountBanner = discountBanner.replace('|PERCENT|', discount);
    if (!document.getElementById('discount-long')) {
      discountContainer.innerHTML = discountBanner;
    }

    // Enable the options
    document.querySelector('[data-upsell-options]').classList.remove('hidden');
    initAccessoryEventListeners();
    return true;
  }

  function createProductCard(item) {
    var displayTitle = item.productTitle;
    var displayTitleMobile;
    var productCardData;
    if (item.quantity > 1) {
      displayTitle += 's';
    }
    displayTitleMobile = displayTitle.replace('Simba', 'Simba<br />');
    productCardData = {
      savingAmountLeft: `|PERCENT|% OFF`,
      savingAmountRight: `YOU SAVE ${formatWithoutTrailingZeros(item.savingTotalRaw * item.quantity)}`,
      originalPriceFinal: formatWithoutTrailingZeros(item.originalPrice * item.quantity),
      priceFinal: format(item.price * item.quantity),
      image: {
        src: {
          desktop: item.image,
          mobile: item.imageMobile
        },
        alt: item.productTitle
      },
      title: {
        desktop: displayTitle,
        mobile: displayTitleMobile
      },
      description: {
        desktop: item.description,
        mobile: item.description
      },
      quantity: item.quantity,
      benefitsRows: createBenefitsContent(item),
      variantId: item.variant_id
    };
    return productCardData;
  }

  function createBenefitsContent(item) {
    var content = '';
    var benefitImage = '';
    var benefit;
    item.benefits.forEach((benefitId) => {
      benefit = Simba.Upsell.accessories.benefits.find((ben) => ben.id === benefitId);
      benefitImage = Simba.Upsell.accessory_benefit_images[benefitId];
      content += `<div class="product-card-body__benefit-row">
        <div class="bundle-benefits-icon m-auto">
          <img src="${benefitImage}" style="height:20px;">
        </div>
        <div class="bundle-benefits-description">
          <span>${benefit.text}</span>
        </div>
      </div>`;
    });
    return content;
  }

  /** Show the upsell drawer */
  function showAccessoryUpsell() {
    document.querySelector('html').classList.add('accessory-upsell-drawer-open');
    document.body.classList.add('accessory-upsell-drawer-show');
    Simba.Event.emit('upsellOpened');
    return true;
  }

  /** Hide the upsell drawer */
  function hideAccessoryUpsell() {
    document.querySelector('html').classList.remove('accessory-upsell-drawer-open');
    document.body.classList.remove('accessory-upsell-drawer-show');
    return true;
  }

  function initAccessoryEventListeners() {
    var closeTriggerAccessory;
    var upgradeTriggerAccessory;
    var selectbuttons;
    /* Event listeners */
    /* DRAWER */
    /* Accept/Reject */

    closeTriggerAccessory = document.querySelector('[data-accessory-upsell-drawer-close]');
    upgradeTriggerAccessory = document.querySelector('[data-accessory-upsell-accept]');
    closeTriggerAccessory.addEventListener('click', rejectAccessoryUpsell);
    upgradeTriggerAccessory.addEventListener('click', upsellAccessoryAccept);

    /* Accessory button */
    selectbuttons = document.querySelectorAll('[data-accessory-product-select]');
    selectbuttons.forEach(function (selectbutton) {
      selectbutton.addEventListener('click', accessorySelect);
    });
  }

  function accessorySelect(e) {
    var button = e.target;
    var selectButtonTexts = document.querySelector('[data-selected-text]');
    var selectText = selectButtonTexts.dataset.selectText;
    var selectedText = selectButtonTexts.dataset.selectedText;
    var addToBasketButton = document.querySelector('[data-accessory-upsell-accept]');
    var selectButtons = document.querySelectorAll('[data-accessory-product-select]');
    var disableAddToBasketButton = true;

    if (button.classList.contains('selected')) {
      button.classList.remove('selected');
      button.innerHTML = selectText;
      button.parentElement.setAttribute('data-accessory-product-select', false);
    } else {
      button.classList.add('selected');
      button.innerHTML = selectedText;
      button.parentElement.setAttribute('data-accessory-product-select', true);
    }

    selectButtons.forEach(function (selectButton) {
      if (selectButton.getAttribute('data-accessory-product-select') === 'true') {
        disableAddToBasketButton = false;
      }
    });

    if (disableAddToBasketButton) {
      addToBasketButton.setAttribute('disabled', '');
    } else {
      addToBasketButton.removeAttribute('disabled');
    }
  }

  function upsellAccessoryAccept() {
    var items = getSelectedAccessories();
    if (items.length > 0) {
      Simba.AjaxCart.cartCall(window.Simba.Lang.url + `/cart/add.js`, 'POST', { items: items })
        .then(() => {
          Simba.AjaxCart.refresh(false);
        })
        .then(hideAccessoryUpsell);
    }
  }

  function getSelectedAccessories() {
    var selectbuttons = document.querySelectorAll('[data-accessory-product-select]');
    var items = [];
    var buttonSelected;

    selectbuttons.forEach(function (button) {
      buttonSelected = button.dataset.accessoryProductSelect;
      if (buttonSelected === 'true') {
        items.push({
          id: button.dataset.variantId,
          quantity: button.dataset.variantQuantity
        });
      }
    });
    return items;
  }
})();
